<template style="display: flex">
    <v-card class="add-user-card" light>
        <v-row width="100%" class="ma-0 pa-0 add-user-header">
            <v-col cols="auto" class="ma-0 pa-0">
                <v-tabs v-model="active_tab" align-tabs="start" light>
                    <v-tab class="tool-navigation-bar" href="#addUser">Add users</v-tab>
                    <v-tab class="tool-navigation-bar" href="#inviteUser">Invite user</v-tab>
                    <v-tab class="tool-navigation-bar" href="#createUser">Create user</v-tab>
                </v-tabs>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
                <v-icon @click="close">mdi-close</v-icon>
            </v-col>
        </v-row>

        <v-tabs-items
            class="ma-0 pa-0 add-user-tabs"
            v-model="active_tab"
        >
            <v-tab-item
                class="add-user-tab"
                value="addUser"
            >
                <div class="add-user-content">
                    <v-row width="100%" class="ma-0 pa-0">
                        <v-text-field
                            class="ma-0 pa-3 user-add-input"
                            label="Search user"
                            prepend-inner-icon="mdi-magnify"
                            outlined
                            hide-details="auto"
                            @input="search_user_debounce"
                        ></v-text-field>
                    </v-row>
                    <v-row width="100%" class="ma-0 pa-0">
                        <div class="user-domain-list">
                            <v-expansion-panels multiple flat>
                                <v-expansion-panel
                                    v-for="group in groupedFilteredUsers"
                                    :key="group.domain"
                                >
                                    <v-expansion-panel-header class="user-domain-header">
                                        <div class="user-domain-title-group">
                                            <span class="user-add-input-title">{{ group.domain }}</span>
                                            <span class="user-domain-count">({{ group.users.length }})</span>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-list dense class="py-0">
                                            <v-list-item
                                                v-for="user in group.users"
                                                :key="user.userId"
                                            >
                                                <v-list-item-action>
                                                    <v-checkbox
                                                        color="secondary"
                                                        v-model="selectedUsers"
                                                        :value="user.userId"
                                                    ></v-checkbox>
                                                </v-list-item-action>

                                                <v-list-item-content>
                                                    <v-list-item-title class="user-add-input-title">{{ user.name }}</v-list-item-title>
                                                    <v-list-item-subtitle class="user-add-input">{{ user.email }}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </div>
                    </v-row>
                </div>
                <v-row class="ma-0 pa-0 add-user-actions" justify="space-around">
                    <v-btn  color='secondary' class="card-action" :disabled="selectedUsers.length < 1" @click="confirm_add_user" style="width: 20%;">
                        Confirm
                    </v-btn>
                </v-row>
            </v-tab-item>
            <v-tab-item
                class="add-user-tab"
                value="inviteUser"
            >
                <div class="add-user-content">
                    <v-row width="100%" class="ma-0 pa-0">
                        <v-col cols="12">
                            <v-text-field
                                class="ma-0 pa-3 user-add-input"
                                label="Invite user by email"
                                v-model="inviteeEmail"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </div>
                <v-row class="ma-0 pa-0 add-user-actions" justify="space-around">
                    <v-btn color='secondary' class="card-action" @click="invite_user" style="width: 20%;">
                        Invite
                    </v-btn>
                </v-row>
            </v-tab-item>
            <v-tab-item
                class="add-user-tab"
                value="createUser"
            >
                <v-form class="ma-0 pa-0 add-user-form">
                    <div class="add-user-content pa-3">
                        <v-row class="ma-0 pa-0">
                            <v-col cols="12" class="ma-0 pb-1">
                                <span class="user-add-section-title">User Details</span>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field :rules="rules.name" label="First name" required class="user-add-input" v-model="first_name" :disabled="confirm"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field :rules="rules.name" label="Last name" required class="user-add-input" v-model="last_name" :disabled="confirm"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="ma-0 pa-0">
                            <v-col cols="12" class="ma-0 pb-1">
                                <span class="user-add-section-title">Login Credentials</span>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field :rules="rules.email" label="Email" class="user-add-input" v-model="email" :disabled="confirm"></v-text-field>
                            </v-col>
                            <v-col cols="10">
                                <v-text-field :rules="rules.name" label="Password" class="user-add-input" v-model="password" :disabled="confirm"></v-text-field>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="auto" v-if="!confirm">
                                <v-btn icon @click="create_random_password">
                                    <v-icon>
                                        mdi-reload
                                    </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="auto">
                                <v-btn icon @click="copy_text_to_clipboard">
                                    <v-icon>
                                        mdi-content-copy
                                    </v-icon>
                                </v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                    </div>
                    <v-row class="ma-0 pa-0 add-user-actions" justify="space-around">
                        <v-col cols="auto" >
                            <v-btn color='secondary' outlined class="card-action" @click="close">
                                Cancel
                            </v-btn>
                        </v-col>
                        <v-col cols="auto" v-if="!confirm">
                            <v-btn color='secondary' class="card-action" @click="clear_content">
                                Clear
                            </v-btn>
                        </v-col>
                        <v-col cols="auto" v-if="!confirm">
                            <v-btn color='secondary' class="card-action" @click="confirm=true">
                                Invite
                            </v-btn>
                        </v-col>
                        <v-col cols="auto" v-if="confirm">
                            <v-btn color='secondary' class="card-action" @click="update_user_detail">
                                Previous
                            </v-btn>
                        </v-col>
                        <v-col cols="auto" v-if="confirm" @click="create_user">
                            <v-btn color='secondary' class="card-action">
                                Create User
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import admin_api_caller from "@/javascript/user_org_retrieval";
import debounce from 'lodash.debounce';
export default {
    name: 'AddUserCard',
    props: [
        'availableUsers',
    ],
    
    data: () => ({
        selectedUsers: [],
        inviteeEmail: '',
        active_tab: 'addUser',
        first_name: "",
        last_name: "",
        email: '',
        password: '',
        user_search_text: '',
        confirm: false,
        rules: {
          name: [val => (val || '').length > 0 || 'This field is required'],
          email: [value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }]
        }
    }),

    computed: {
        filteredUsers() {
            let filtereduser = {}
            if(this.user_search_text == ''){
                return this.availableUsers;
            } else {
                for(let userId in this.availableUsers){
                    let user = this.availableUsers[userId];
                    if(
                        user.email.toLowerCase().includes(this.user_search_text.toLowerCase()) || 
                        (user.first_name + " " + user.last_name).toLowerCase().includes(this.user_search_text.toLowerCase())
                    ){
                        filtereduser[userId] = user;
                    }
                }
            }
            return filtereduser;
        },
        groupedFilteredUsers() {
            const groupedUsers = {};

            for (let userId in this.filteredUsers) {
                const user = this.filteredUsers[userId];
                const email = user.email || '';
                const emailParts = email.split('@');
                const domain = emailParts.length > 1 ? emailParts[emailParts.length - 1].toLowerCase() : 'unknown';

                if (!groupedUsers[domain]) {
                    groupedUsers[domain] = [];
                }

                groupedUsers[domain].push({
                    userId,
                    name: user.name || `${user.first_name || ''} ${user.last_name || ''}`.trim(),
                    email: user.email
                });
            }

            return Object.keys(groupedUsers)
                .sort((firstDomain, secondDomain) => firstDomain.localeCompare(secondDomain))
                .map((domain) => ({
                    domain,
                    users: groupedUsers[domain].sort((firstUser, secondUser) => firstUser.email.localeCompare(secondUser.email))
                }));
        }
    },

    methods: {
        close: function() {
            this.$emit("close_add_user")
        },
        confirm_add_user: function() {
            this.$emit("add_members_to_org", this.selectedUsers)
        },
        invite_user: function() {
            this.$emit("invite_member_to_org", this.inviteeEmail)
        },
        search_user_debounce: debounce(function(value){
            this.user_search_text = value;
        } ,200),
        create_random_password: function(){
            let pass = Math.random().toString(36).slice(2) + Math.random().toString(36).toUpperCase().slice(2);
            this.password = pass;
        },
        copy_text_to_clipboard: async function(){
            let text = this.password;
            try {
                await navigator.clipboard.writeText(text);
                alert('Content copied to clipboard');
            } catch (err) {
                alert('Failed to copy: ', err);
            }
        },
        clear_content: function(){
            this.first_name = '';
            this.last_name = '';
            this.email = '';
            this.password = '';
        },

        create_user: async function(){
            let user_info = {
                'first_name': this.first_name,
                'last_name': this.last_name,
                'email': this.email,
                'password': this.password
            }

            const token = await this.$auth.getTokenSilently();
            await admin_api_caller.create_new_user(token, user_info)
                .then((resp) => {
                return resp["data"];
                })
                .catch((e) => {
                console.log(e);
                return "False";
                });
            this.close()
        },
        
    }
}
</script>
<style>
    .add-user-card{
        width: 60%;
        height: 90vh;
        margin: 0 auto;
        padding: 12px;
        display: flex !important;
        flex-direction: column;
    }
    .add-user-header{
        flex: 0 0 auto;
    }
    .add-user-tabs{
        width: 100%;
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }
    .add-user-tabs .v-window__container,
    .add-user-tabs .v-window-item{
        flex: 1 1 auto;
        min-height: 0;
    }
    .add-user-tabs .v-window__container{
        display: flex;
        flex-direction: column;
    }
    .add-user-tab,
    .add-user-form{
        height: 100%;
        min-height: 0;
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .add-user-content{
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
    }
    .add-user-actions{
        flex: 0 0 96px;
        min-height: 96px;
        padding: 12px 0 40px !important;
        align-items: center;
    }
    .add-user-actions > .col,
    .add-user-actions > [class*="col-"]{
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }
    .card-title{
        font-family: 'Gothic' !important;
        font-weight: 800 !important;
        font-size: 1.2em !important;
    }
    .card-section-title{
        font-family: 'Gothic' !important;
        font-weight: 600 !important;
        font-size: 1.2em !important;
    }
    .card-action{
        font-family: 'Gothic' !important;
        font-weight: 600 !important;
        font-size: 0.9em !important;
    }
    .user-add-input-title{
        font-family: 'Gothic' !important;
        font-weight: 600 !important;
        font-size: 0.9em !important;
    }
    .user-add-input{
        font-family: 'Gothic' !important;
        font-weight: 400 !important;
        font-size: 0.9em !important;
    }
    .user-add-section-title{
        font-family: 'Gothic' !important;
        font-weight: 600 !important;
        font-size: 1.2em !important;
    }
    .user-domain-list{
        width: 100%;
        padding: 0 12px;
    }
    .user-domain-header{
        min-height: 56px !important;
    }
    .user-domain-title-group{
        display: inline-flex;
        align-items: center;
    }
    .user-domain-count{
        font-family: 'Gothic' !important;
        font-size: 0.85em !important;
        margin-left: 4px;
    }
</style>
  
